import type { ScoreRow } from './scoreDeal';
import { formatPercent, formatRatio } from '../../utils/financialCalculations';

interface Props { rows: ScoreRow[]; profileName: string; }

export default function DecisionScorecard({ rows, profileName }: Props) {
  return (
    <div className="border rounded-xl overflow-hidden">
      <div className="bg-gray-900 text-white px-4 py-2 text-sm font-semibold">
        Decision Scorecard - {profileName}
      </div>
      <table className="w-full text-sm">
        <thead className="bg-gray-100 text-gray-600">
          <tr>
            <th className="text-left px-4 py-2">Metric</th>
            <th className="text-right px-4 py-2">Threshold</th>
            <th className="text-right px-4 py-2">Actual</th>
            <th className="text-right px-4 py-2">Status</th>
          </tr>
        </thead>
        <tbody>
          {rows.map(r => {
            const fmt = r.format === 'percent' ? formatPercent : formatRatio;
            return (
              <tr key={r.key} className="border-t">
                <td className="px-4 py-2">{r.label}</td>
                <td className="px-4 py-2 text-right text-gray-600">&ge; {fmt(r.threshold)}</td>
                {/* An inapplicable metric shows N/A and UNLEVERED, never 0.00x FAIL. An all-cash
                    deal has no debt to cover, so DSCR is not applicable rather than missed -
                    and his delivered analyses print all five rows on every deal. */}
                <td className="px-4 py-2 text-right font-medium">{r.applicable ? fmt(r.actual) : 'N/A'}</td>
                <td className={`px-4 py-2 text-right font-semibold ${
                  !r.applicable ? 'text-gray-500' : r.pass ? 'text-success' : 'text-red-600'
                }`}>
                  {!r.applicable ? 'UNLEVERED' : r.pass ? 'PASS' : 'FAIL'}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
